<script>
	import { onMount } from 'svelte';
	import { currentUser } from './store.js';
	import { authAPI } from './api.js';
	import LandingPage from './LandingPage.svelte';
	import Login from './Login.svelte';
	import Dashboard from './Dashboard.svelte';
	import Toaster from './lib/Toaster.svelte';

	let isAuthenticated = $state(false);
	let showLogin = $state(false);

	onMount(() => {
		isAuthenticated = authAPI.isAuthenticated();
		if (isAuthenticated) {
			currentUser.set(authAPI.getCurrentUser());
			showLogin = true;
		} else {
			// Deep links from recovery/verification emails skip the landing
			const params = new URLSearchParams(window.location.search);
			if (params.get('reset_token') || params.get('verify_token')) {
				showLogin = true;
			}
		}
	});

	function goToLogin() {
		showLogin = true;
	}
</script>

<main>
	{#if isAuthenticated}
		<Dashboard />
	{:else if showLogin}
		<Login />
	{:else}
		<LandingPage onGoToLogin={goToLogin} />
	{/if}
	<Toaster />
</main>

<style>
	main {
		width: 100%;
		height: 100vh;
		height: 100dvh; /* track the visible viewport on mobile (keyboard/chrome) */
	}
</style>
